export const HEADER_HEIGHT = 65;
export const TABS_HEIGHT = 61;
export const SIDEBAR_WIDTHS = [0, 72, 72, 300];
